module.exports = __webpack_public_path__ + "assets/1f44e41d28786a2b324a1b9f0d0a7b16.json";